import React from 'react';

import { CreateAccountingFirmContext } from './CreateAccountingFirmContext';
import { EditAccountingFirmContext } from './EditAccountingFirmContext';

const useCreateAccountingFirmContext = () => React.useContext(CreateAccountingFirmContext);
const useEditAccountingFirmContext = () => React.useContext(EditAccountingFirmContext);

export { useCreateAccountingFirmContext, useEditAccountingFirmContext };
